import { useIsomorphicLayoutEffect } from '@contra/react-hooks/useIsomorphicLayoutEffect';

let changeCount = 0;
let originalBodyPointerEvents: string;

const useDisableBodyPointerEvents = ({ disabled }: { disabled: boolean }) => {
  useIsomorphicLayoutEffect(() => {
    if (disabled) {
      if (changeCount === 0) {
        originalBodyPointerEvents = document.body.style.pointerEvents;
      }

      document.body.style.pointerEvents = 'none';
      changeCount++;

      return () => {
        changeCount--;
        if (changeCount === 0) {
          document.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }

    return () => {};
  }, [disabled]);
};

export { useDisableBodyPointerEvents };
